export function hokSetTimeoutAsync(ms:number)
{
    return new Promise((resolve)=>{

        setTimeout(resolve, ms);
    });

}